require("./legend");

require("./legend/ScrollableLegendModel");

require("./legend/ScrollableLegendView");

require("./legend/scrollableLegendAction");


//////////////////
// WEBPACK FOOTER
// ../~/echarts/lib/component/legendScroll.js
// module id = 2162
// module chunks = 1